import {useQuery} from 'react-query';
import getMyStoreAds from './getMyStoreAds';

const useGetMyStoreAds = (params: IGetMyStoreAdsParams) => {
  const {data, isLoading, isFetching, refetch} = useQuery({
    queryKey: ['get-my-store-ads', params],
    queryFn: () =>
      getMyStoreAds({
        payload: params,
      }),
  });

  return {
    data,
    isLoading,
    isFetching,
    refetch,
  };
};

export default useGetMyStoreAds;
